import type { MenuCategory } from '../types/menu'

export const menuData: MenuCategory[] = [
  {
    id: 'tacos',
    title: 'Street Tacos',
    description:
      'Served on doubled corn tortillas with onion, cilantro & lime. Swap to flour at no charge.',
    items: [
      {
        name: 'Carne Asada',
        price: '$3.50',
        description: 'Grilled marinated steak, chopped fine',
        popular: true,
      },
      {
        name: 'Al Pastor',
        price: '$3.50',
        description: 'Achiote-marinated pork with grilled pineapple',
        popular: true,
      },
      {
        name: 'Pollo Asado',
        price: '$3.25',
        description: 'Citrus-grilled chicken thigh',
      },
      {
        name: 'Chorizo',
        price: '$3.25',
        description: 'House-seasoned Mexican sausage',
        spicy: true,
      },
      {
        name: 'Carnitas',
        price: '$3.50',
        description: 'Slow-braised pork, crisped on the flat-top',
      },
      {
        name: 'Birria',
        price: '$4.50',
        description: 'Slow-cooked beef, crispy & cheesy, with consommé',
        options: 'Extra consommé +$1.50',
      },
      {
        name: 'Baja Fish',
        price: '$4.25',
        description: 'Beer-battered cod, cabbage slaw, chipotle crema',
      },
      {
        name: 'Veggie',
        price: '$3.00',
        description: 'Grilled peppers, onions, black beans & queso fresco',
      },
    ],
    notices: ['Add cheese, sour cream or guacamole +$0.75 each'],
  },
  {
    id: 'burritos',
    title: 'Burritos',
    description:
      'Big flour tortilla stuffed with Mexican rice, pinto beans, cheese & your choice of meat.',
    items: [
      {
        name: 'Classic Burrito',
        price: '$11',
        description: 'Your choice of asada, pastor, chicken, carnitas or chorizo',
      },
      {
        name: 'California Burrito',
        price: '$13',
        description: 'Carne asada, crispy fries, cheese, sour cream & pico',
        popular: true,
      },
      {
        name: 'Burrito Mojado',
        price: '$13',
        description: 'Smothered in red sauce & melted cheese — fork required',
      },
      {
        name: 'Breakfast Burrito',
        price: '$9',
        description: 'Eggs, chorizo, potatoes & cheese. Served until 11am weekends',
      },
      {
        name: 'Bean & Cheese',
        price: '$7',
        description: 'Refried beans, melted cheese & salsa roja',
      },
    ],
  },
  {
    id: 'quesadillas',
    title: 'Quesadillas',
    items: [
      {
        name: 'Cheese Quesadilla',
        price: '$8',
        description: 'Oaxaca & jack cheese on a grilled flour tortilla',
      },
      {
        name: 'Meat Quesadilla',
        price: '$11',
        description: 'Choice of meat with cheese, served with pico & sour cream',
      },
      {
        name: 'Quesabirria',
        price: '$13',
        description: 'Birria beef & cheese, griddled crisp, with consommé',
        popular: true,
      },
    ],
  },
  {
    id: 'nachos-bowls',
    title: 'Nachos & Bowls',
    items: [
      {
        name: 'Loaded Nachos',
        price: '$12',
        description:
          'House chips, queso, beans, choice of meat, pico, jalapeños & sour cream',
        options: 'Add guacamole +$2',
      },
      {
        name: 'Burrito Bowl',
        price: '$12',
        description: 'Everything in a burrito — rice, beans, meat, cheese & salsa — no tortilla',
      },
      {
        name: 'Elote Bowl',
        price: '$6',
        description: 'Roasted street corn, mayo, cotija, chile & lime',
      },
    ],
  },
  {
    id: 'sides',
    title: 'Sides',
    items: [
      { name: 'Chips & Salsa', price: '$4' },
      { name: 'Chips & Queso', price: '$6' },
      { name: 'Chips & Guacamole', price: '$7' },
      { name: 'Mexican Rice', price: '$3.99' },
      { name: 'Refried Beans', price: '$3' },
      { name: 'Elote (on the cob)', price: '$5', description: 'Mexican street corn' },
    ],
    notices: [
      'Salsas: Verde (Mild), Roja (Medium), Habanero (Hot) — free with any order',
    ],
  },
  {
    id: 'drinks',
    title: 'Drinks & Sweets',
    items: [
      { name: 'Mexican Coke', price: '$3.50', description: 'Glass bottle, real cane sugar' },
      { name: 'Jarritos', price: '$3', description: 'Mandarin, Tamarind, Lime or Pineapple' },
      { name: 'Horchata', price: '$4', description: 'House-made rice & cinnamon' },
      { name: 'Agua Fresca', price: '$4', description: 'Rotating seasonal flavor' },
      { name: 'Bottled Water', price: '$1.50' },
      {
        name: 'Churros',
        price: '$5',
        description: 'Three fresh churros, cinnamon sugar, chocolate dip',
      },
    ],
  },
]
